"use strict";
module.exports = validate20;
module.exports.default = validate20;
var schema22 = { "$schema": "http://json-schema.org/draft-07/schema#", "additionalProperties": false, "definitions": { "DisableOptions": { "additionalProperties": false, "properties": { "name": { "description": "Feature to disable in the query\nExample: \"facet\", \"item\", \"group\", \"redirect\"", "type": "string" } }, "required": ["name"], "type": "object" }, "FacetRequestOptions": { "additionalProperties": false, "properties": { "attribute": { "description": "Selected facet to filter by\nTODO: Should be removed after migration to ids", "type": "string" }, "id": { "description": "Selected facet to filter by", "type": "string" }, "values": { "description": "Values of the facet used for filtering the results", "items": { "type": "string" }, "type": "array" } }, "required": ["values"], "type": "object" }, "SortOptions": { "additionalProperties": false, "properties": { "attribute": { "description": "Attribute to sort by", "type": "string" }, "order": { "description": "Order of the sort.\nMust be either \"asc\" or \"desc\"", "type": "string" } }, "required": ["attribute", "order"], "type": "object" } }, "properties": { "aiSearch": { "description": "Toggle AI Search \"on\" or \"off\".\nIf true, AI Search is used\nIf false, regular fulltext search is used\nIf not specified, the type of search will be determined by the configuration", "type": "boolean" }, "customResponseMask": { "description": "Response mask to return only specific attributes of items", "type": "string" }, "disable": { "description": "DEPRECATED: top-level `disable` feature should be used instead", "items": { "$ref": "#/definitions/DisableOptions" }, "type": "array" }, "facets": { "items": { "$ref": "#/definitions/FacetRequestOptions" }, "type": "array" }, "filter": { "description": "Filter string", "type": "string" }, "limit": { "description": "Pagination: size of the page", "type": "number" }, "offset": { "description": "Pagination: index of the first item to return", "type": "number" }, "sortBy": { "description": "List of sorting rules\n(applied in order)", "items": { "$ref": "#/definitions/SortOptions" }, "type": "array" } }, "type": "object" };
var schema23 = { "additionalProperties": false, "properties": { "name": { "description": "Feature to disable in the query\nExample: \"facet\", \"item\", \"group\", \"redirect\"", "type": "string" } }, "required": ["name"], "type": "object" };
var schema24 = { "additionalProperties": false, "properties": { "attribute": { "description": "Selected facet to filter by\nTODO: Should be removed after migration to ids", "type": "string" }, "id": { "description": "Selected facet to filter by", "type": "string" }, "values": { "description": "Values of the facet used for filtering the results", "items": { "type": "string" }, "type": "array" } }, "required": ["values"], "type": "object" };
var schema25 = { "additionalProperties": false, "properties": { "attribute": { "description": "Attribute to sort by", "type": "string" }, "order": { "description": "Order of the sort.\nMust be either \"asc\" or \"desc\"", "type": "string" } }, "required": ["attribute", "order"], "type": "object" };
function validate20(data, valCxt) {
    "use strict";
    ;
    if (valCxt) {
        var instancePath = valCxt.instancePath;
        var parentData = valCxt.parentData;
        var parentDataProperty = valCxt.parentDataProperty;
        var rootData = valCxt.rootData;
    }
    else {
        var instancePath = "";
        var parentData = undefined;
        var parentDataProperty = undefined;
        var rootData = data;
    }
    var vErrors = null;
    var errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for (var key0 in data) {
            if (!((((((((key0 === "aiSearch") || (key0 === "customResponseMask")) || (key0 === "disable")) || (key0 === "facets")) || (key0 === "filter")) || (key0 === "limit")) || (key0 === "offset")) || (key0 === "sortBy"))) {
                var err0 = { instancePath: instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema22, data: data };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.aiSearch !== undefined) {
            var data0 = data.aiSearch;
            if (typeof data0 !== "boolean") {
                var err1 = { instancePath: instancePath + "/aiSearch", schemaPath: "#/properties/aiSearch/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema22.properties.aiSearch.type, parentSchema: schema22.properties.aiSearch, data: data0 };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.customResponseMask !== undefined) {
            var data1 = data.customResponseMask;
            if (typeof data1 !== "string") {
                var err2 = { instancePath: instancePath + "/customResponseMask", schemaPath: "#/properties/customResponseMask/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.customResponseMask.type, parentSchema: schema22.properties.customResponseMask, data: data1 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.disable !== undefined) {
            var data2 = data.disable;
            if (Array.isArray(data2)) {
                var len0 = data2.length;
                for (var i0 = 0; i0 < len0; i0++) {
                    var data3 = data2[i0];
                    if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                        if (data3.name === undefined) {
                            var err3 = { instancePath: instancePath + "/disable/" + i0, schemaPath: "#/definitions/DisableOptions/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'", schema: schema23.required, parentSchema: schema23, data: data3 };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                        for (var key1 in data3) {
                            if (!(key1 === "name")) {
                                var err4 = { instancePath: instancePath + "/disable/" + i0, schemaPath: "#/definitions/DisableOptions/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties", schema: false, parentSchema: schema23, data: data3 };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                        }
                        if (data3.name !== undefined) {
                            var data4 = data3.name;
                            if (typeof data4 !== "string") {
                                var err5 = { instancePath: instancePath + "/disable/" + i0 + "/name", schemaPath: "#/definitions/DisableOptions/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.name.type, parentSchema: schema23.properties.name, data: data4 };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err6 = { instancePath: instancePath + "/disable/" + i0, schemaPath: "#/definitions/DisableOptions/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.type, parentSchema: schema23, data: data3 };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err7 = { instancePath: instancePath + "/disable", schemaPath: "#/properties/disable/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.disable.type, parentSchema: schema22.properties.disable, data: data2 };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
        }
        if (data.facets !== undefined) {
            var data5 = data.facets;
            if (Array.isArray(data5)) {
                var len1 = data5.length;
                for (var i1 = 0; i1 < len1; i1++) {
                    var data6 = data5[i1];
                    if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                        if (data6.values === undefined) {
                            var err8 = { instancePath: instancePath + "/facets/" + i1, schemaPath: "#/definitions/FacetRequestOptions/required", keyword: "required", params: { missingProperty: "values" }, message: "must have required property '" + "values" + "'", schema: schema24.required, parentSchema: schema24, data: data6 };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                        for (var key2 in data6) {
                            if (!(((key2 === "attribute") || (key2 === "id")) || (key2 === "values"))) {
                                var err9 = { instancePath: instancePath + "/facets/" + i1, schemaPath: "#/definitions/FacetRequestOptions/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties", schema: false, parentSchema: schema24, data: data6 };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        if (data6.attribute !== undefined) {
                            var data7 = data6.attribute;
                            if (typeof data7 !== "string") {
                                var err10 = { instancePath: instancePath + "/facets/" + i1 + "/attribute", schemaPath: "#/definitions/FacetRequestOptions/properties/attribute/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema24.properties.attribute.type, parentSchema: schema24.properties.attribute, data: data7 };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                        }
                        if (data6.id !== undefined) {
                            var data8 = data6.id;
                            if (typeof data8 !== "string") {
                                var err11 = { instancePath: instancePath + "/facets/" + i1 + "/id", schemaPath: "#/definitions/FacetRequestOptions/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema24.properties.id.type, parentSchema: schema24.properties.id, data: data8 };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                        }
                        if (data6.values !== undefined) {
                            var data9 = data6.values;
                            if (Array.isArray(data9)) {
                                var len2 = data9.length;
                                for (var i2 = 0; i2 < len2; i2++) {
                                    var data10 = data9[i2];
                                    if (typeof data10 !== "string") {
                                        var err12 = { instancePath: instancePath + "/facets/" + i1 + "/values/" + i2, schemaPath: "#/definitions/FacetRequestOptions/properties/values/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema24.properties.values.items.type, parentSchema: schema24.properties.values.items, data: data10 };
                                        if (vErrors === null) {
                                            vErrors = [err12];
                                        }
                                        else {
                                            vErrors.push(err12);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                var err13 = { instancePath: instancePath + "/facets/" + i1 + "/values", schemaPath: "#/definitions/FacetRequestOptions/properties/values/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema24.properties.values.type, parentSchema: schema24.properties.values, data: data9 };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err14 = { instancePath: instancePath + "/facets/" + i1, schemaPath: "#/definitions/FacetRequestOptions/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema24.type, parentSchema: schema24, data: data6 };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err15 = { instancePath: instancePath + "/facets", schemaPath: "#/properties/facets/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.facets.type, parentSchema: schema22.properties.facets, data: data5 };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.filter !== undefined) {
            var data11 = data.filter;
            if (typeof data11 !== "string") {
                var err16 = { instancePath: instancePath + "/filter", schemaPath: "#/properties/filter/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.filter.type, parentSchema: schema22.properties.filter, data: data11 };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.limit !== undefined) {
            var data12 = data.limit;
            if (!((typeof data12 == "number") && (isFinite(data12)))) {
                var err17 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.limit.type, parentSchema: schema22.properties.limit, data: data12 };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.offset !== undefined) {
            var data13 = data.offset;
            if (!((typeof data13 == "number") && (isFinite(data13)))) {
                var err18 = { instancePath: instancePath + "/offset", schemaPath: "#/properties/offset/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.offset.type, parentSchema: schema22.properties.offset, data: data13 };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.sortBy !== undefined) {
            var data14 = data.sortBy;
            if (Array.isArray(data14)) {
                var len3 = data14.length;
                for (var i3 = 0; i3 < len3; i3++) {
                    var data15 = data14[i3];
                    if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        if (data15.attribute === undefined) {
                            var err19 = { instancePath: instancePath + "/sortBy/" + i3, schemaPath: "#/definitions/SortOptions/required", keyword: "required", params: { missingProperty: "attribute" }, message: "must have required property '" + "attribute" + "'", schema: schema25.required, parentSchema: schema25, data: data15 };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data15.order === undefined) {
                            var err20 = { instancePath: instancePath + "/sortBy/" + i3, schemaPath: "#/definitions/SortOptions/required", keyword: "required", params: { missingProperty: "order" }, message: "must have required property '" + "order" + "'", schema: schema25.required, parentSchema: schema25, data: data15 };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                        for (var key3 in data15) {
                            if (!((key3 === "attribute") || (key3 === "order"))) {
                                var err21 = { instancePath: instancePath + "/sortBy/" + i3, schemaPath: "#/definitions/SortOptions/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties", schema: false, parentSchema: schema25, data: data15 };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                        }
                        if (data15.attribute !== undefined) {
                            var data16 = data15.attribute;
                            if (typeof data16 !== "string") {
                                var err22 = { instancePath: instancePath + "/sortBy/" + i3 + "/attribute", schemaPath: "#/definitions/SortOptions/properties/attribute/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema25.properties.attribute.type, parentSchema: schema25.properties.attribute, data: data16 };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                        }
                        if (data15.order !== undefined) {
                            var data17 = data15.order;
                            if (typeof data17 !== "string") {
                                var err23 = { instancePath: instancePath + "/sortBy/" + i3 + "/order", schemaPath: "#/definitions/SortOptions/properties/order/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema25.properties.order.type, parentSchema: schema25.properties.order, data: data17 };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err24 = { instancePath: instancePath + "/sortBy/" + i3, schemaPath: "#/definitions/SortOptions/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema25.type, parentSchema: schema25, data: data15 };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err25 = { instancePath: instancePath + "/sortBy", schemaPath: "#/properties/sortBy/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.sortBy.type, parentSchema: schema22.properties.sortBy, data: data14 };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
    }
    else {
        var err26 = { instancePath: instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data };
        if (vErrors === null) {
            vErrors = [err26];
        }
        else {
            vErrors.push(err26);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validateSearchItemOptionsSchema.js.map